import React, { useState } from "react";
import Switch from "../../ui_atoms/Switch";
import VStack from "../../ui_atoms/VStack";
import type { Meta } from "@storybook/react";
import type { StoryObj } from "@storybook/react";
function SwitchStoryComponent({ disabled }: { disabled: boolean }) {
    const [switch1, setSwitch1] = useState(true);
    const [switch2, setSwitch2] = useState(true);
    const [switch3, setSwitch3] = useState(true);
    const [switch4, setSwitch4] = useState(true);

    return (
        <VStack gap={0.5} h={0.5} v={0.5}>
            <Switch
                value={switch3}
                onChange={setSwitch3}
                label="With label on right"
                labelPosition="left"
                disabled={disabled}
            />
            <Switch
                value={switch4}
                onChange={setSwitch4}
                label="With extra long label on right, which should allow multiple line, to make sure it doesn't overflow"
                labelPosition="left"
                disabled={disabled}
            />
            <Switch value={switch1} onChange={setSwitch1} label="With label" disabled={disabled} />
            <Switch value={switch2} onChange={setSwitch2} disabled={disabled} />
        </VStack>
    );
}

const meta = {
    title: "Atom/Switch",
    component: SwitchStoryComponent,
    argTypes: {
        disabled: {
            control: "boolean",
        },
    },
} satisfies Meta<typeof SwitchStoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Basic: Story = {
    args: {
        disabled: false,
    },
};
